let addedLinks = [];
const searchTermOutputDir = '/wp-content/victaulic-search-terms/';
const searchResultsUrl = `${window.location.protocol}//${window.location.hostname}?s=`;

const matchMethod = (termData, phrase) => {
    if (phrase.length < 2) {
      return false;
    }
    const term = String(termData.term).toLowerCase().replace(/[^0-9a-z]/gi, '');
    const userInput = String(phrase).toLowerCase().replace(/[^0-9a-z]/gi, '');
    const link = String(termData.link);

    if (
        term.search(userInput) > -1
        && addedLinks.indexOf(link) === -1
        ) {
      addedLinks.push(link);
      return true;
    }
    return false;
};

const searchInput = (e, autoCompleteOptions) => {
    const $this = $(e.target);
    const value = String($this.val()).toLowerCase();
    if (!value) {
      return false;
    }
    if (value.length < 2) {
      return false;
    }
    const newUrl = `${searchResultsUrl}${value}`;
    addedLinks = [];

    // update search form action with search term
    $this.attr('data-action', newUrl);

    if (value.length >= 2) {
      $this.easyAutocomplete({
          ...autoCompleteOptions,
          url: `${searchTermOutputDir}${value[0]}${value[1]}.json`,
      });
    }
    $this.trigger('focus');
    return true;
};

const searchKeyUp = (event, inputEl) => {
    if ($('.header-search').hasClass('active')) {
      // enter
      if (event.which === 13) {
        const selected = inputEl.getSelectedItemData();
        window.location = selected.length ? selected.link : inputEl.attr('data-action');
      }
    }
};

const searchHeaderInit = () => {
    $('.js-search').on('click', (event) => {
      event.preventDefault();
      // Deactivate the language selector.
      $('.top-navigation .js-smt-lang-selector').removeClass('active');
      $('.header-search').toggleClass('active');
      $('.header-search input.autocomplete').trigger('focus').val('');
    });

    $('.search-close').on('click', (event) => {
      event.preventDefault();
      $('.header-search').removeClass('active');
    });
};

const searchAutoCompleteOptions = (inputEl) => ({
    url: '',
    getValue: (termData) => termData,
    list: {
        maxNumberOfElements: 10,
        sort: {
            enabled: true,
            method: (a, b) => {
                if (a.order < b.order) {
                    return -1;
                }
                if (a.order > b.order) {
                    return 1;
                }
                return 0;
            },
        },
        match: {
            enabled: true,
            method: (termData, phrase) => matchMethod(termData, phrase),
            caseSensitive: true,
        },
        onSelectItemEvent() {
            // update action with search term.
            const selected = inputEl.getSelectedItemData();
            inputEl.attr('data-action', selected.link);
        },
        onLoadEvent() {
            $('.easy-autocomplete-container li').removeClass('selected');
            addedLinks = [];
        },
        onHideListEvent() {
            inputEl.trigger('focus');
            addedLinks = [];
        },
    },
    template: {
        type: 'custom',
        method: (value, item) => `<a href="${item.link}" title="${item.title}">${item.title}</a>`,
    },
});

(($) => {

    const inputEl = $('input.autocomplete');

    searchHeaderInit();

    const options = searchAutoCompleteOptions(inputEl);

    // when the first character is entered, set the url
    // to the correct file and initiate easy-autocomplete
    inputEl.on('input', (event) => searchInput(event, options));

    // Handle keypress "Enter" and "Tab" when search is open.
    $(document).on('keyup', (event) => searchKeyUp(event, inputEl));
})(jQuery);
